/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { styled } from '@mui/material/styles';
import { CarouselProvider as PRCarouselProvider } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

export const CarouselProvider = styled(PRCarouselProvider)({});
